/**
 * 解密成功混合数据（PC/Vue 浏览器版本）
 * @param {Object} res - { text: base64字符串, key: base64字符串 }
 * @returns {Object} 解析后的 JSON 对象
 */
export function decryptSuccessMix(res) {
  const { text, key } = res;

  // 1. base64 解码 → ArrayBuffer (浏览器方式)
  const xor1 = base64ToArrayBuffer(text);
  const xor2 = new Uint8Array(xor1);

  const rea1 = base64ToArrayBuffer(key);
  const rea2 = new Uint8Array(rea1);

  // 2. XOR 异或
  const bytes = new Uint8Array(xor2.length);
  for (let i = 0; i < xor2.length; i++) {
    bytes[i] = xor2[i] ^ rea2[i % rea2.length];
  }

  // 3. Uint8Array 转字符串
  const jsonStr = uint8ArrayToString(bytes);

  return JSON.parse(jsonStr);
}

/**
 * base64 字符串转 ArrayBuffer（浏览器兼容）
 */
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

/**
 * Uint8Array 转字符串（支持中文）
 */
function uint8ArrayToString(uint8Array) {
  let binaryStr = '';
  for (let i = 0; i < uint8Array.length; i++) {
    binaryStr += '%' + ('0' + uint8Array[i].toString(16)).slice(-2);
  }
  return decodeURIComponent(binaryStr);
}



// WEBPACK FOOTER //
// ./src/assets/common.js